import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconKeyboardComponent } from "./med-icon-keyboard.component";

@NgModule({
  declarations: [
    MedIconKeyboardComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconKeyboardComponent,
  ],
})
export class MedIconKeyboardModule { }
